import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import HorizontalNameValue from '../../components/library/layout/HorizontalNameValue'
import { TurnedInNot } from '@mui/icons-material';
import HrbTranslate from '../../components/language/HrbTranslate'
import DateTime from '../../components/library/common/DateTime'
import './PaymentInfo.scss'
import EmdashText from '../library/common/EmdashText';

const PaymentInfo = (props) => {
    const { payments } = props;    
    const lang = useSelector(state => state.layout.lang)

    const frenchCurrency = (str) => {
        return str.toString().replace(',', ' ').replace('.', ',') + ' $';
    }

    const purchaseStatusTranslation = (str) => {
        if (str.toLowerCase() === 'success') {
            return 'ReturnInfo.Labels.Success'
        }
        else if (str.toLowerCase() === 'card failure') {
            return 'ReturnInfo.Labels.CardFailure'
        }
        return str
    }

    const getTotalTax = (gst, pst, hst, tax) => {
        var g = !gst ? 0 : parseFloat(gst)
        var p = !pst ? 0 : parseFloat(pst)
        var h = !hst ? 0 : parseFloat(hst)
        var t = !tax ? 0 : parseFloat(tax)

        return (g + p + h + t).toFixed(2)
    }

    const paymentInformation = () => {
        var paymentInfo = [];
        if (payments) {
            if (payments.length !== 0) {
                for (var i = 0; i < payments.length; ++i) {
                    var orderId = ''
                    if (i === 0) {
                        orderId = payments[i].orderId
                    }
                    else if (i > 0) {
                        if (payments[i].orderId === payments[i - 1].orderId) {
                            orderId = ''
                        }
                        else {
                            orderId = payments[i].orderId
                            paymentInfo.push(<hr key={'hr' + i}/>)
                        }
                    }
                    if (orderId === '') {
                        paymentInfo.push(<div key={'payment' + i} className='columns tickets'></div>)
                    }
                    else {
                        paymentInfo.push(<div key={'payment' + i} className='columns tickets payment-info-row-spacing mb-3'>
                            <div className='column is-1 is-offset-1'>
                                {payments &&
                                    <div className='level'>
                                        <TurnedInNot className='level-left' style={{ color: '#3F3F3F' }} />
                                        <h5 className='level-item ml-2'>{orderId}</h5>
                                    </div>
                                }
                            </div>
                        </div>)
                    }
                    paymentInfo.push(
                        <div key={'paymentInfo' + i}>
                            <div className='columns tickets'>
                                <div className='column is-8'>
                                    <div className='column is-8 payment-sku-title-offset'>
                                        {payments &&
                                            <h5>{payments[i].productSkuName || payments[i].productSkuNameEn}</h5>
                                        }
                                    </div>
                                    
                                    <div className='column is-8 is-offset-3'>
                                        <div className='columns tickets payment-info-row-spacing'>
                                            <div className='column is-8'>
                                                <p className='p1'><HrbTranslate text='ReturnInfo.Labels.PurchaseDate' /></p>
                                                <p className='p1 bold-weight'><DateTime value={payments[i].purchaseDate} dateAndTime /></p>
                                            </div>
                                            <div className='column is-6'>
                                                <p className='p1'><HrbTranslate text='ReturnInfo.Labels.PurchaseStatus' /></p>
                                                <p className='p1 bold-weight'>{payments[i].purchaseStatus ? <HrbTranslate text={purchaseStatusTranslation(payments[i].purchaseStatus)} /> : <EmdashText /> }</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='column is-3'>
                                    <div className='has-text-right'>
                                        <div className='payment-info-row-spacing'>
                                            {payments &&
                                                <HorizontalNameValue
                                                textKey="ReturnInfo.Labels.Subtotal"
                                                value={lang === 'en' ? '$' + parseFloat(payments[i].subTotal).toFixed(2) : frenchCurrency(parseFloat(payments[i].subTotal).toFixed(2))}
                                                loading={!payments} boldValue={true}/>
                                            }
                                        </div>
                                        <div>
                                            {payments &&
                                                <HorizontalNameValue
                                                    textKey="ReturnInfo.Labels.Tax"
                                                    value={lang === 'en' ? '$' + getTotalTax(payments[i].gst, payments[i].pst, payments[i].hst, payments[i].tax) : frenchCurrency(getTotalTax(payments[i].gst, payments[i].pst, payments[i].hst, payments[i].tax))}
                                                loading={!payments} boldValue={true} />
                                            }
                                        </div>
                                        <div className='payment-info-total-spacing'>
                                            <div className='mb-5' />
                                            {payments &&
                                                <HorizontalNameValue
                                                textKey="ReturnInfo.Labels.Total"
                                                value={lang === 'en' ? '$' + parseFloat(payments[i].total).toFixed(2) : frenchCurrency(parseFloat(payments[i].total).toFixed(2))}
                                                loading={!payments}
                                                boldText={true} boldValue={true} />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>)  
                }
            }
            else {
                paymentInfo.push(<div key='no-payments' className='columns'><div className='column is-offset-1 is-10'><EmdashText /></div></div>)
            }
        }
        return paymentInfo
    }

        return (
            <div id='payment-box'>
                <Fragment>
                    <div className='column is-5 payment-info-top-margin'>
                        {payments &&
                            <h4 className ='ml-3'><HrbTranslate text='ReturnInfo.Headers.PaymentInformation' /></h4>
                        }
                    </div>
                    <div className='hr-top-margin'>
                        <hr />
                    </div>                   
                    {paymentInformation()}
                    <div className='payment-info-bottom-margin'></div>
                </Fragment>
            </div>
        );
    
}

PaymentInfo.whyDidYouRender = false;

PaymentInfo.propTypes = {
    payments: PropTypes.array,
    lang: PropTypes.string
}

export default PaymentInfo